import {
  ButtonsMessage as ButtonsMessageType,
  Conversation,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui/deprecated';
import {ChatRow} from '../../../Chat';
import {ButtonsMessage} from './ButtonsMessage';

type Props = {
  conversation: Conversation;
  message: ButtonsMessageType;
};

export const ButtonsMessageRow = ({conversation, message}: Props) => {
  const row = (
    <ChatRow>
      <ButtonsMessage conversation={conversation} message={message} />
    </ChatRow>
  );
  return <view.div data-testid="buttons-message-row">{row}</view.div>;
};
